import { render, staticRenderFns } from "./UsMobile.vue?vue&type=template&id=6349dbbf&scoped=true&"
import script from "./UsMobile.vue?vue&type=script&lang=js&"
export * from "./UsMobile.vue?vue&type=script&lang=js&"
import style0 from "./UsMobile.vue?vue&type=style&index=0&id=6349dbbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6349dbbf",
  null
  
)

export default component.exports